// src/pages/Home.jsx
import Hero from '../components/home/Hero';
import TrustedBy from '../components/home/TrustedBy';
import SkiperBanner from '../components/home/SkiperBanner';

import Team from '../components/home/Company';
import Footer from '../components/Footer';
import PreFooter from '../components/PreFooter';
import NewsArticles from '../components/Project/SKIPER/NewsArticles';

const Home = () => (
  <>
    <Hero />
    
    <SkiperBanner />
    <NewsArticles />
    <Team />
    <TrustedBy />
    <PreFooter />
    <Footer />
  </>
);

export default Home;
